import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux'
import "react-alice-carousel/lib/alice-carousel.css";

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';

//Store import
import Configure from './config/store'

//Components Imports
import Route from './config/routes';

//Style imports
import './css/header.css';
import './css/entertainment.css';
import './css/bio-index.css'
import './css/millenials.css'
import './css/menu.css'
import './css/bio.css'
import './css/contact.css'
import './css/view-millenials.css'
import './css/view-entertaiment.css'
import './css/footer.css'
import './index.css';

const store = Configure()

const render = (
    <Provider store={store}>
        <Route/>
    </Provider>
)

ReactDOM.render(render, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js